// @flow

import OrderSummaryInfo from './OrderSummaryInfo'

export default OrderSummaryInfo
